import { BlogArticle } from '../types';

// IELTS Writing Task 2 七分攻略 → CTA: /module/writing
const article: BlogArticle = {
  slug: 'ielts-writing-task2-band7',
  date: '2026-09-12',
  readingMinutes: 5,
  tags: ['IELTS', 'Writing', '作文'],

  locales: {
    zhHant: {
      title: 'IELTS Writing Task 2：攞 7 分的 5 個關鍵',
      excerpt: 'Task 2 成日卡喺 6.5？由 6.5 上 7 分，唔係要寫深詞，而係要避開呢幾個扣分位。',
      keywords: 'IELTS, IELTS Writing, Task 2, band 7, 雅思作文',
      contentHtml: `
        <p>好多考生嘅英文其實唔差，但 Task 2 就係卡喺 6 或者 6.5。由 6.5 上 7，通常唔係因為詞彙唔夠深，而係以下五個位未做好。</p>

        <h2>1. 審題：答非所問係最大扣分位</h2>
        <p>Task Response 佔 25% 分數。題目問 "To what extent do you agree or disagree?"，你就一定要清楚表態同貫徹立場；問 "Discuss both views"，你就兩邊都要講。<strong>用 2 分鐘劃出題目關鍵字先好落筆。</strong></p>

        <h2>2. 結構：四段式最穩陣</h2>
        <ol>
          <li><strong>Introduction</strong>：改寫題目 + 表明立場（2–3 句）</li>
          <li><strong>Body 1</strong>：主題句 + 解釋 + 例子</li>
          <li><strong>Body 2</strong>：第二個論點，同樣結構</li>
          <li><strong>Conclusion</strong>：總結立場（1–2 句，唔好加新論點）</li>
        </ol>

        <h2>3. 每段一個中心句（Topic Sentence）</h2>
        <p>考官睇卷好快，每段第一句一定要講明呢段講咩。例如：<em>"Firstly, online learning offers unmatched flexibility."</em> 一句講晒，之後先解釋。</p>

        <h2>4. 連接詞要用得自然</h2>
        <p>Cohesion 唔係堆砌 "Moreover, Furthermore, Nevertheless"。7 分嘅連接係自然嘅：用代詞（this, such, they）、同義改寫去銜接句子，連接詞適量就夠。</p>

        <h2>5. 詞彙貴精唔貴深</h2>
        <p>Lexical Resource 睇嘅係<strong>準確同多樣</strong>，唔係艱深。與其用錯大詞，不如將 "important" 換成 "crucial / essential / vital" 呢啲你一定用得啱嘅字。</p>

        <div class="tip-box">
          <strong>💡 貼士：</strong>7 分作文唔使完美 —— 官方標準容許少量錯誤。與其追求零錯，不如確保立場清晰、結構完整。
        </div>

        <h2>寫完點知道自己有冇 7 分？</h2>
        <p>搵人批改最準，但老師唔係成日得閒。AI 批改可以即時按 IELTS 四項準則（TR / CC / LR / GRA）俾分，仲會列出錯誤同修訂版：</p>
        <p><a class="blog-cta-button" href="/module/writing">✍️ 免費批改 IELTS 作文 →</a></p>
      `,
    },

    zhHans: {
      title: 'IELTS Writing Task 2：拿 7 分的 5 个关键',
      excerpt: 'Task 2 总是卡在 6.5？从 6.5 上 7 分，不是要写难词，而是要避开这几个扣分点。',
      keywords: 'IELTS, IELTS Writing, Task 2, band 7, 雅思作文',
      contentHtml: `
        <p>很多考生的英文其实不差，但 Task 2 就是卡在 6 或 6.5。从 6.5 上 7，通常不是因为词汇不够深，而是以下五个地方没做好。</p>

        <h2>1. 审题：答非所问是最大扣分点</h2>
        <p>Task Response 占 25% 分数。题目问 "To what extent do you agree or disagree?"，你就一定要清楚表态并贯彻立场；问 "Discuss both views"，你就两边都要讲。<strong>先用 2 分钟划出题目关键字再动笔。</strong></p>

        <h2>2. 结构：四段式最稳妥</h2>
        <ol>
          <li><strong>Introduction</strong>：改写题目 + 表明立场（2–3 句）</li>
          <li><strong>Body 1</strong>：主题句 + 解释 + 例子</li>
          <li><strong>Body 2</strong>：第二个论点，同样结构</li>
          <li><strong>Conclusion</strong>：总结立场（1–2 句，不要加新论点）</li>
        </ol>

        <h2>3. 每段一个中心句（Topic Sentence）</h2>
        <p>考官看卷很快，每段第一句一定要说明这段讲什么。例如：<em>"Firstly, online learning offers unmatched flexibility."</em> 一句讲完，之后再解释。</p>

        <h2>4. 连接词要用得自然</h2>
        <p>Cohesion 不是堆砌 "Moreover, Furthermore, Nevertheless"。7 分的衔接是自然的：用代词（this, such, they）、同义改写来衔接句子，连接词适量就够。</p>

        <h2>5. 词汇贵精不贵难</h2>
        <p>Lexical Resource 看的是<strong>准确和多样</strong>，不是艰深。与其用错大词，不如把 "important" 换成 "crucial / essential / vital" 这些你一定用得对的字。</p>

        <div class="tip-box">
          <strong>💡 提示：</strong>7 分作文不用完美 —— 官方标准允许少量错误。与其追求零错，不如确保立场清晰、结构完整。
        </div>

        <h2>写完怎么知道自己有没有 7 分？</h2>
        <p>找人批改最准，但老师不是随时有空。AI 批改可以即时按 IELTS 四项准则（TR / CC / LR / GRA）给分，还会列出错误和修订版：</p>
        <p><a class="blog-cta-button" href="/module/writing">✍️ 免费批改 IELTS 作文 →</a></p>
      `,
    },

    en: {
      title: 'IELTS Writing Task 2: The 5 Keys to a Band 7',
      excerpt: "Stuck at 6.5 on Task 2? Getting to Band 7 isn't about fancier words — it's about avoiding these five mark-losing habits.",
      keywords: 'IELTS, IELTS Writing, Task 2, band 7, essay writing',
      contentHtml: `
        <p>Plenty of candidates have decent English, yet Task 2 keeps them stuck at 6 or 6.5. Moving from 6.5 to 7 usually isn't about deeper vocabulary — it's about fixing these five things.</p>

        <h2>1. Answer the question — literally</h2>
        <p>Task Response is 25% of your score. If the prompt says "To what extent do you agree or disagree?", you must take a clear, consistent position. If it says "Discuss both views", you must cover both. <strong>Spend 2 minutes highlighting the keywords before you write.</strong></p>

        <h2>2. Structure: the four-paragraph format is safest</h2>
        <ol>
          <li><strong>Introduction</strong>: paraphrase the prompt + state your position (2–3 sentences)</li>
          <li><strong>Body 1</strong>: topic sentence + explanation + example</li>
          <li><strong>Body 2</strong>: second argument, same structure</li>
          <li><strong>Conclusion</strong>: restate your position (1–2 sentences, no new ideas)</li>
        </ol>

        <h2>3. One topic sentence per paragraph</h2>
        <p>Examiners read fast. The first sentence of each paragraph must say what the paragraph is about: <em>"Firstly, online learning offers unmatched flexibility."</em> Then explain.</p>

        <h2>4. Use cohesive devices naturally</h2>
        <p>Cohesion isn't stacking "Moreover, Furthermore, Nevertheless". Band-7 cohesion is subtle: pronouns (this, such, they) and paraphrasing link sentences together. Use connectors sparingly.</p>

        <h2>5. Vocabulary: precise beats fancy</h2>
        <p>Lexical Resource rewards <strong>accuracy and range</strong>, not difficulty. Rather than misusing an impressive word, swap "important" for "crucial / essential / vital" — words you can use correctly every time.</p>

        <div class="tip-box">
          <strong>💡 Tip:</strong> A Band 7 essay doesn't need to be perfect — the descriptors allow occasional errors. A clear position and solid structure matter more than flawless grammar.
        </div>

        <h2>How do you know if your essay is Band 7?</h2>
        <p>A teacher's feedback is best, but teachers aren't always available. AI grading scores your essay instantly on all four IELTS criteria (TR / CC / LR / GRA), with a mistake list and a revised version:</p>
        <p><a class="blog-cta-button" href="/module/writing">✍️ Grade my IELTS essay for free →</a></p>
      `,
    },
  },
};

export default article;
